import { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { DialogProps } from '@/types/interfaces';
import { CrossIcon, CrossBlackIcon } from "@/components/assets/icons/svgs";

function Popup({
    headerTitle,
    title,
    size,
    isOpen,
    handleSubmit,
    handleClose,
    bodyChildren,
    footerChildren,
    isShowCloseIcon = true,
    isShowDeleteIcon = true,
    isShowBlackCrossIcon = false,
    isShowDivider = false,
    slotProps,
    className,
    contentSx
}: DialogProps & { className?: string; contentSx?: any }) {

    return (
        <Dialog
            open={isOpen}
              onClose={(event, reason) => {
    // Prevent closing on backdrop click for special popups
    if (slotProps?.preventOutsideClose && reason === 'backdropClick') return;

    handleClose?.(event, reason);
  }}
            maxWidth={size || 'md'}
            fullWidth
            disableScrollLock   // ✅ Prevents scrollbar from being hidden
            slotProps={{
                ...slotProps,
                paper: {
                    className,
                    sx: {
                        borderRadius: 3,
                        boxShadow: 3,
                        backgroundColor: 'background.paper',
                        ...(slotProps?.paper?.sx || {}),
                    },
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, textTransform: 'none', color: '#000', fontFamily: 'Object Sans, sans-serif' }}>
                    {headerTitle}
                </span>
                {isShowCloseIcon && (
                    <IconButton className='!p-0 absolute right-5 top-5' onClick={handleClose} size="small">
                        {!isShowBlackCrossIcon ? <CrossIcon /> : <CrossBlackIcon />}
                    </IconButton>
                )}
            </DialogTitle>
            {isShowDivider && <Divider />}
            {bodyChildren && <DialogContent sx={contentSx}>{bodyChildren}</DialogContent>}
            {footerChildren && <DialogActions>{footerChildren}</DialogActions>}
        </Dialog>
    );
}

export default Popup;
